export const DEFAULT_SIZE = '44px';
